module.exports = __webpack_public_path__ + "static/media/website-ipad-iphone.9c374b9d.png";